module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "gv-legend-layer-table"
    }
  }, [_vm._c('el-table', {
    staticStyle: {
      "width": "100%",
      "line-height": "23px",
      "font-weight": "400"
    },
    attrs: {
      "data": _vm.map.layers,
      "show-header": false,
      "size": "mini",
      "empty-text": " ",
      "row-class-name": _vm.layerClassName
    }
  }, [_vm._c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "30"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._c('img', {
          attrs: {
            "alt": scope.row.legend.label,
            "src": _vm.iconUrl(scope.row),
            "width": "20"
          },
          on: {
            "click": function($event) {
              _vm.showLegendPanel(scope.row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.layerVisibilityCheck) ? _vm._c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "25"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._c('span', [_vm._c('el-checkbox', {
          staticClass: "gv-layer-visibility-cb",
          attrs: {
            "disabled": !scope.row.inRange
          },
          on: {
            "change": function($event) {
              _vm.setLayerVisible(scope.row)
            }
          },
          model: {
            value: (scope.row.visible),
            callback: function($$v) {
              _vm.$set(scope.row, "visible", $$v)
            },
            expression: "scope.row.visible"
          }
        }, [_vm._v("layer-visibility")])], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _vm._c('el-table-column', {
    staticStyle: {
      "word-break": "normal"
    },
    attrs: {
      "class-name": "gv-inverted-color-scheme-light"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.inRange),
            expression: "!scope.row.inRange"
          }],
          attrs: {
            "trigger": "hover",
            "placement": "left-start",
            "offset": "10",
            "popper-class": "gv-layer-popover"
          }
        }, [_vm._c('p', [_vm._v(_vm._s(scope.row.scaleRangeLabel))]), _vm._v(" "), _vm._c('div', {
          staticClass: "gv-legend-popover-button"
        }, [_vm._c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.options.layerPopover && _vm.options.layerPopover.find),
            expression: "options.layerPopover && options.layerPopover.find"
          }],
          staticClass: "gv-color-scheme gv-legend-map-tools-button",
          attrs: {
            "title": "Ricerca sul livello",
            "icon": "el-icon-search",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.layerSearch(scope.row)
            }
          }
        })], 1), _vm._v(" "), _vm._c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\n            " + _vm._s(scope.row.legend.label) + "\n          ")])]), _vm._v(" "), (_vm.options.layerPopover && scope.row.inRange) ? _vm._c('el-popover', {
          attrs: {
            "trigger": "hover",
            "popper-class": "popover-scala",
            "placement": "left-start",
            "width": "150",
            "offset": "15"
          }
        }, [_vm._c('div', {
          staticClass: "gv-legend-transparency-layer-slider"
        }, [_vm._c('el-slider', {
          on: {
            "change": function($event) {
              _vm.setLayerTransparency(scope.row)
            }
          },
          model: {
            value: (scope.row.opacityBase100),
            callback: function($$v) {
              _vm.$set(scope.row, "opacityBase100", $$v)
            },
            expression: "scope.row.opacityBase100"
          }
        })], 1), _vm._v(" "), _vm._c('el-row', {
          staticClass: "row-bg gv-legend-popover-buttons",
          attrs: {
            "type": "flex",
            "justify": "left"
          }
        }, [_vm._c('div', {
          staticClass: "gv-legend-popover-button"
        }, [_vm._c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.options.layerPopover && _vm.options.layerPopover.find),
            expression: "options.layerPopover && options.layerPopover.find"
          }],
          staticClass: "gv-color-scheme gv-legend-map-tools-button",
          attrs: {
            "title": "Ricerca sul livello",
            "icon": "el-icon-search",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.layerSearch(scope.row)
            }
          }
        })], 1), _vm._v(" "), _vm._c('div', {
          staticClass: "gv-legend-popover-button"
        }, [_vm._c('el-checkbox', {
          staticClass: "gv-layer-visibility-cb",
          on: {
            "change": function($event) {
              _vm.setLayerVisible(scope.row)
            }
          },
          model: {
            value: (scope.row.visible),
            callback: function($$v) {
              _vm.$set(scope.row, "visible", $$v)
            },
            expression: "scope.row.visible"
          }
        }, [_vm._v("layer-visibility")])], 1)]), _vm._v(" "), _vm._c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\n            " + _vm._s(scope.row.legend.label) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.options.layerPopover && scope.row.inRange),
            expression: "!options.layerPopover && scope.row.inRange"
          }],
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("\n          " + _vm._s(scope.row.legend.label) + "\n        ")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3048f14a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegendLayers.vue
// module id = 839
// module chunks = 39